import { useAuth } from '@/hooks/useAuth'
import { AlertCircle } from 'lucide-react'

export const DemoBanner = () => {
  const { isDemoUser } = useAuth()

  if (!isDemoUser) return null

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex items-center gap-2 text-amber-800">
          <AlertCircle className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            <span className="font-bold">Demo Mode:</span> You're viewing a read-only demo account.
            You can explore all features and open forms, but changes won't be saved.
            Demo data resets daily at 3 AM UTC.
          </p>
        </div>
      </div>
    </div>
  )
}
